/* eslint-disable react/display-name */
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// import Swiper core and required modules
import SwiperCore, { EffectCoverflow, Pagination, Navigation } from 'swiper/core';

// install Swiper modules
SwiperCore.use([EffectCoverflow, Pagination, Navigation]);

import TestimonialStyles from '../../styles/elements/TestimonialSlider.module.scss';
import { PortableText } from '../../lib/sanity';

const serializers = {
  marks: {
    link: ({ children, mark }) =>
      mark.blank ? (
        <a href={mark.href} target="_blank" rel="noopener noreferrer">
          {children}
        </a>
      ) : (
        <a href={mark.href}>{children}</a>
      )
  }
};

const TestimonialsSlider = ({ Testimonials }) => {
  return (
    <div>
      <Swiper
        className={TestimonialStyles.holder}
        spaceBetween={30}
        navigation={true}
        watchOverflow={true}
        centeredSlidesBounds={true}
        breakpoints={{
          0: {
            slidesPerView: 1,
            spaceBetween: 40
          },
          992: {
            slidesPerView: 3,
            spaceBetween: 60
          }
        }}
        grabCursor={false}
        centeredSlides={true}
      >
        {Testimonials?.length > 0 &&
          Testimonials.map((testimonial) => (
            <SwiperSlide key={testimonial._id} className={TestimonialStyles.slide}>
              <div className={TestimonialStyles.quote}>
                <PortableText blocks={testimonial.testimonial} serializers={serializers} />
              </div>
              <div className={TestimonialStyles.person}>
                <div className={TestimonialStyles.name}>{testimonial.name}</div>
                <div className={TestimonialStyles.position}>{testimonial.position}</div>
              </div>
            </SwiperSlide>
          ))}
      </Swiper>
    </div>
  );
};

export default TestimonialsSlider;
